import { Component, OnInit, HostListener, Input } from '@angular/core';
import { HomeService } from '../_services/home.service';
import { Footer, FooterContent } from '../_model/footer';

import {DomSanitizer} from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
export let checkCaseModalInHome = false;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  footer: Footer;
  footerContent: FooterContent = {};
  screenHeight: any;
  screenWidth: any;
  image: any;
  articleId: any;
  copyright: any;
  articleTitle: any;
  topArticle: any=[];
  mediaTitle: any;
  checkCaseModalInHome: boolean = false;
  disableLiveChatSHP: any;
  constructor(private homeService: HomeService,
    private router: Router,private route: ActivatedRoute,
              private sanitizer: DomSanitizer) {
    this.getScreenSize();
   }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }
  ngOnInit() {
    this.homeService.getShpLogin().subscribe(res=>{
      this.disableLiveChatSHP = res.return_body.disable_live_chat_SHP
      })

    this.getFooterConfig();
    this.getTopArticlesTitle();
  }
  getTopArticlesTitle(){
    
    this.homeService.getTopArticles().subscribe(res =>{
      this.topArticle= res.return_body;
    })
  }

  getFooterConfig() {
    this.homeService.getFooterConfig().subscribe(res => {
      if(res.return_body!=null){
      if(res.return_body.mediaTitle==null || res.return_body.mediaTitle=="" ){
        this.mediaTitle = "Media Links"
    }
      else{
      
      this.mediaTitle = res.return_body.mediaTitle;
      } 
    }
      this.footer = res.return_body;
      this.copyright = this.sanitizer.bypassSecurityTrustHtml(this.footer.copyRightContent);
      this.footer.footerText.forEach(data => {
        switch (data.key) {
          case 'Need help title':
            this.footerContent.needHelpTitle = data.text;
            break;
          case 'Need help content':
            this.footerContent.needHelpContent = data.text;
            break;
          case 'Call number':
            this.footerContent.callNumber = data.text;
            break;
          case 'Call number content':
            this.footerContent.callNumberContent = data.text;
            this.footerContent.callNumberIcon = data.type;
            break;
          case 'Call number2':
            this.footerContent.callNumber2 = data.text;
            break;
          case 'Call number content2':
            this.footerContent.callNumberContent2 = data.text;
            this.footerContent.callNumberIcon2 = data.type;
            break;
          case 'Call number3':
            this.footerContent.callNumber3 = data.text;
            break;
          case 'Call number content3':
            this.footerContent.callNumberContent3 = data.text;
            this.footerContent.callNumberIcon3 = data.type;
            break;
          case 'Call number4':
            this.footerContent.callNumber4 = data.text;
            break;
          case 'Call number content4':
            this.footerContent.callNumberContent4 = data.text;
            this.footerContent.callNumberIcon4 = data.type;
            break;        
          case 'Call number5':
            this.footerContent.callNumber5 = data.text;
            break;
          case 'Call number content5':
            this.footerContent.callNumberContent5 = data.text;
            this.footerContent.callNumberIcon5 = data.type;
            break;                                           
          case 'Chat':
            this.footerContent.chatContent = data.text;
            this.footerContent.chatIcon = data.type;
            break;
          case 'Create case title':
            this.footerContent.createCase = data.text;
            this.footerContent.createCaseIcon = data.type;
            break;
          case 'Additional Info':
              this.footerContent.additionalInfo = data.text;
            break;
        }
      });
    });
  }
  handleNavigate(pathValue) {
    if (pathValue == 'case') {
      this.checkCaseModalInHome = true;
     // this.router.navigate([this.router.url.split("/")[1], 'createcase']);
  }
  if (pathValue == 'chat') {
    this.router.navigate([this.router.url.split("/")[1],'chat-user-interface']);
}
}
handleNavigation(article){
  this.router.navigate(['/' + this.router.url.split('/')[1] + '/article'], { queryParams: {articleId: article.article_id}});
}
openChat(){
  this.homeService.openChat.next(true);
}

  getImage(img) {
    if (this.screenWidth <= 768) {
      return img.smallImageURL;
    } else {
      return img.largeImageURL;
    }
  }

  checkIsCaseModalOpen(event){
    this.checkCaseModalInHome = false;
  }

}
